import PropTypes from 'prop-types';
import React from 'react';
import { Button, OverlayTrigger, Popover, Glyphicon, Checkbox, Row, Col, } from 'react-bootstrap';
import { humanize, titleize } from 'underscore.string';
import Input from 'components/ui/input';
import { withTranslation } from 'react-i18next';
class ItemSelection extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.getInitialState();
    }
    getInitialState() {
        return {
            items: this.props.items,
            active: this.props.active,
        };
    }
    renderNewName(item) {
        const { t } = this.props;
        if (item === 'contents_weight') {
            return React.createElement("p", { style: { marginTop: '10px' } }, t('WEIGHT'));
        }
        return React.createElement("p", { style: { marginTop: '10px' } }, titleize(humanize(t(item))));
    }
    onChange(value, checked) {
        const state = Object.assign({}, this.state);
        if (checked) {
            state.active.push(value);
        }
        else {
            const idx = state.active.indexOf(value);
            state.active.splice(idx, 1);
        }
        this.setState(state);
        this.props.onChange(state.active);
    }
    renderPopup() {
        return (React.createElement(Popover, { id: "item-selection-popup" },
            React.createElement("ul", { className: "filter-dropdown-wrapper" }, this.props.items.map((item) => (React.createElement("li", { key: item },
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 1 },
                        React.createElement(Checkbox, { "data-key": "items", checked: this.props.active.indexOf(item) > -1, onChange: () => this.onChange(item, !(this.props.active.indexOf(item) > -1)) })),
                    React.createElement(Col, { xs: 10 }, this.renderNewName(item)))))))));
    }
    render() {
        return (React.createElement("div", { className: this.props.className },
            React.createElement(OverlayTrigger, { trigger: "click", rootClose: true, placement: "bottom", overlay: this.renderPopup() },
                React.createElement("div", null,
                    React.createElement(Button, { bsSize: "small", bsStyle: "default", style: { outline: 'none' }, disabled: this.props.disabled },
                        this.props.category,
                        " ",
                        React.createElement(Glyphicon, { glyph: this.props.glyph }))))));
    }
}
ItemSelection.propTypes = {
    onChange: PropTypes.func.isRequired,
    items: PropTypes.array.isRequired,
    active: PropTypes.array.isRequired,
    className: PropTypes.string,
    category: PropTypes.string.isRequired,
    glyph: PropTypes.string.isRequired,
};
ItemSelection.defaultProps = {
    className: null,
};
export default withTranslation()(ItemSelection);
